// Clave de encriptación (en producción debería estar en variables de entorno)
const ENCRYPTION_KEY = 'prospectia-secure-key-2024';

// Funciones de encriptación y desencriptación
const encryptData = (data) => {
    try {
        const jsonString = JSON.stringify(data);
        if (jsonString === undefined) return null;
        // Encriptación simple usando base64 + XOR con la key
        let encrypted = '';
        for (let i = 0; i < jsonString.length; i++) {
            const charCode = jsonString.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length);
            encrypted += String.fromCharCode(charCode);
        }
        return btoa(encrypted); // Convertir a base64
    } catch (error) {
        console.error('Error encriptando datos:', error);
        return null;
    }
};

const decryptData = (encryptedData) => {
    try {
        if (!encryptedData) return null;

        // Verificar si los datos parecen estar encriptados (base64 válido)
        if (typeof encryptedData !== 'string' || encryptedData.length === 0) {
            throw new Error('Datos no válidos para desencriptar');
        }

        // Desencriptación: base64 + XOR con la key
        const decoded = atob(encryptedData);
        let decrypted = '';
        for (let i = 0; i < decoded.length; i++) {
            const charCode = decoded.charCodeAt(i) ^ ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length);
            decrypted += String.fromCharCode(charCode);
        }
        return JSON.parse(decrypted);
    } catch (error) {
        // Re-lanzar el error para que secureGetItem lo maneje
        throw error;
    }
};

// Funciones seguras para localStorage
export const secureSetItem = (key, value) => {
    try {
        const encryptedValue = encryptData(value);
        if (encryptedValue) {
            localStorage.setItem(key, encryptedValue);
            return true;
        }
        return false;
    } catch (error) {
        console.error('Error guardando datos encriptados:', error);
        return false;
    }
};

export const secureGetItem = (key) => {
    try {
        let value = localStorage.getItem(key);
        if (!value) return null;

        // Si el valor es exactamente "[object Object]", lo ignoramos
        if (value === "[object Object]") return null;

        // Intentar desencriptar primero (datos nuevos)
        try {
            return decryptData(value);
        } catch (decryptError) {
            // Si falla la desencriptación, intentar parsear como JSON (datos antiguos)
            try {
                return JSON.parse(value);
            } catch (parseError) {
                // Si también falla el parse, devolver el valor tal como está (strings simples)
                return value;
            }
        }
    } catch (error) {
        console.error('Error obteniendo datos:', error);
        return null;
    }
};

export const secureRemoveItem = (key) => {
    try {
        localStorage.removeItem(key);
        return true;
    } catch (error) {
        console.error('Error removiendo datos encriptados:', error);
        return false;
    }
}; 